import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_ID } from "../firebase.config";
import { useContext, useEffect, useState } from "react";
import { DataContext } from "../Context/DataContext";
import { getClientSecret} from "../Data/Functions";
import ExpressCheckoutElement from "./ExpressCheckoutElement";
import Loader from "./Loader";
import { Check } from "react-feather";
import { AuthContext } from "../Context/AuthContext";

const StripeExpressCheckout = ({ id, amount, onStripeReady, saveCard, setSaveCard, item, number, type }) => {
    const  {userData, teamData} = useContext(DataContext);
    const  {signedIn} = useContext(AuthContext);
    const [clientSecret, setClientSecret] = useState("");

    const [isCardSelected, setIsCardSelected] = useState(true);

     const [stripePromise, setStripePromise] = useState(false);

     const [loadStripeElement, setLoadStripeElement] = useState(false);
    
      useEffect(() => {
        if(!stripePromise){
          setStripePromise(loadStripe(STRIPE_ID));
        }

        setTimeout(() => {
          setLoadStripeElement(true);
        }, 1000);
      }, [stripePromise])

      useEffect(() => {
        if(!loadStripeElement){
          return;
        }
        setClientSecret(null);
        getClientSecret(type, item, number, userData ? userData.email : item.email || "", amount, id, userData, teamData, false, saveCard).then(key => setClientSecret(key));
      }, [userData, teamData, id, saveCard, amount, loadStripeElement])

      const options = {
        appearance: {theme: "stripe"}, 
        layout: {
          type: 'tabs',
          defaultCollapsed: false,
        },
        variables: {
          colorPrimary: "#4EC1D0", 
          colorBackground: "#fff",
          colorText: "#2d2d2d",
          colorDanger: "#FF8080",
          fontFamily: "Inter, sans-serif",
          borderRadius: "6px",
        },
        rules: { 
          ".Input": {outline: "none", boxShadow: "none"},
          ".Input:focus": {outline: "none", boxShadow: "none", border: 0},
          ".PaymentElement": {outline: "none", boxShadow: "none", border: 0},
        },
      }   
    if(!clientSecret || !stripePromise || !loadStripeElement){
        return <div className="container mx-auto w-full h-[100px] flex items-center justify-center">
        <Loader />
      </div>
    }


  return <Elements stripe={stripePromise} options={{...options, clientSecret }}>
    {signedIn && clientSecret &&
        isCardSelected && (
          <div
            className="hardCopyCheckboxLine justify-end p-2 pb-0 pt-0"
            onClick={() => {
              setSaveCard((prev) => !prev);
            }}
          >
            <div className={`${saveCard ? "hardCopyChecked" : ""} hardCopyCheckbox`}>
              <Check
                className="hardCopyCheck"
                style={{ opacity: saveCard ? 1 : 0 }}
              />
            </div>
            <p className="hardCopyCheckboxText text-[13px]">Securly save the card for faster checkouts</p>
          </div>
        )}
    <ExpressCheckoutElement onStripeReady={onStripeReady} setIsCardSelected={setIsCardSelected}/>
  </Elements>
};

export default StripeExpressCheckout;
